module.exports = __webpack_public_path__ + "img/Khwaka-Rinah.27923cf1.jpeg";